import React from 'react'
import { useMediaQuery } from 'react-responsive'

import { Button, FlatButton, theme } from '@acorns/grove'
import styled from 'styled-components'

import { SKIP_BUTTON } from 'utils/testing/testIDs'

const StyledSkipButton = styled(Button)`
  padding: 12px 24px;
  font-size: 14px;
  width: 120px;
  white-space: nowrap;

  @media (max-width: ${theme.dimensions.breakpointsSmall}px) {
    margin-left: -75px;
  }
`

const StyledSkipFlatButton = styled(FlatButton)`
  white-space: nowrap;
  position: relative;
  z-index: 1;
  margin-left: -40px;
  padding: 0;

  &:active,
  &:focus {
    outline: none;
    opacity: 0.8;
  }
`

interface SkipButtonProps {
  onClick: () => void
  children: React.ReactNode
}

export const SkipButton = ({ onClick, children }: SkipButtonProps) => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.dimensions.breakpointsSmall}px)`,
  })

  return isMobile ? (
    <StyledSkipFlatButton
      testId={SKIP_BUTTON}
      onClick={onClick}
      linkColor={theme.colors.primaryStone}
      variant={'secondary'}
    >
      {children}
    </StyledSkipFlatButton>
  ) : (
    <StyledSkipButton
      testId={SKIP_BUTTON}
      onClick={onClick}
      inkOpacity={0.02}
      secondary
    >
      {children}
    </StyledSkipButton>
  )
}
